// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import { isNullOrUndefined } from '@shared/utils';
import { AggregatorProvider } from '../types/brokerage-types';
import { isNuvaraInversisInstitution } from './nuvara-inversis-institution';

/**
 * Check if the institution is a manual Citec bulk-upload bank.
 *
 * @remarks
 * Nuvara Inversis also uses the `citec` provider but is a special managed account
 * (not a manual bulk upload), so it is explicitly excluded.
 * @param institution - Institution object with a `provider` slug (and optional
 *   id/institution_id used to rule out Nuvara Inversis).
 * @returns True when the provider is `citec` and it is not Nuvara Inversis.
 */
export const isManualCitecInstitution = <
  T extends { provider?: string; id?: string; institution_id?: string },
>(
  institution: T | null | undefined,
): boolean => {
  if (isNullOrUndefined(institution)) {
    return false;
  }

  return (
    institution.provider === AggregatorProvider.Citec &&
    !isNuvaraInversisInstitution(institution)
  );
};
